import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BASE_URI, config } from '../../app.config';
import { Subject } from 'rxjs';

@Injectable()
export class PasswordResetService {

  /** specifying Base URL.*/


  public BASE_URL = BASE_URI.URL;

  private _getEmailId = new Subject();
  authenticateEmailId$ = this._getEmailId.asObservable();

  constructor(private http: HttpClient) { }

  requestResetPassword(data) {
    return this.http.post(`${this.BASE_URL}/newPassword`, data);
  };

  getUserEmailId(email_id){
    this._getEmailId.next(email_id);
  }

};
